import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TranslatorContext } from "../context/Translator";
import { SidebarContext } from "../context/Sidebar";
import sidenavs from "../assets/data/sidenavs.json";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL, TOKEN } from "../helper/BASE_URL";

export default function SidebarLayout() {
  const { t, n, currentLanguage } = useContext(TranslatorContext);
  const { sidebar, handleSidebarClose } = useContext(SidebarContext);
  const [isMobile, setIsMobile] = useState(false);
  const [getDataas, setGetDataas] = useState(null);

  const navigate = useNavigate();

  const handleDropdown = (event) => {
    const buttonElement = event.currentTarget;
    const itemElement = buttonElement.parentElement;
    const isActive = itemElement.classList.contains("active");
    const allItems = document.querySelectorAll(".mc-sidebar-menu-item");
    const allDropdowns = document.querySelectorAll(".mc-sidebar-dropdown-list");
    const dropdownElement = itemElement.querySelector(
      ".mc-sidebar-dropdown-list"
    );

    if (isActive) {
      itemElement.classList.remove("active");
      dropdownElement.style.height = "0px";
    } else {
      allItems.forEach((item) => item.classList.remove("active"));
      allDropdowns.forEach((dropdown) => (dropdown.style.height = "0px"));

      itemElement.classList.add("active");
      dropdownElement.style.height = dropdownElement.scrollHeight + "px";
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("jwt");
    // navigate("/");
    window.location.replace("https://bosspanda.io");
  };

  // Check if the window width is in mobile range
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth < 768); // e.g., 768px breakpoint for mobile
  };

  // Update mobile state on window resize
  useEffect(() => {
    checkIsMobile(); // Check on component mount

    // Add event listener to handle window resize
    window.addEventListener("resize", checkIsMobile);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  const handleOptionClick = (element, text) => {
    if (text == "Logout") {
      localStorage.removeItem("jwt");
      window.location.replace("https://bosspanda.io");
    }
    if (isMobile) {
      handleSidebarClose();
    }
  };

  useEffect(() => {
    Handle_Enter_OTP();
  }, []);

  const Handle_Enter_OTP = () => {
    const getData = localStorage.getItem("jwt");
    const parseIt = JSON.parse(getData);

    try {
      axios
        .post(
          BASE_URL + "get_user_profile.php",
          {
            userid: parseIt.reg_em,
            token: parseIt.boss_token,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log("xxxxxx");
          console.log(acc.data.data.reg_date);
          console.log("xxxxxx");

          let gettingDate = acc.data.data.reg_date;

          let dateObj = new Date(gettingDate);

          let cutoffDate = new Date("2024-09-01T00:00:00Z");

          let isBeforeSeptember1st = dateObj < cutoffDate;

          setGetDataas(isBeforeSeptember1st);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <aside
      as="aside"
      className={`mc-sidebar thin-scrolling ${sidebar && "active"}`}
    >
      {sidenavs?.map((sidenav, sidenavIndex) => (
        <menu key={sidenavIndex} className="mc-sidebar-menu">
          <ul className="mc-sidebar-menu-list">
            {sidenav.menus.map((menu, menuIndex) => (
              <li key={menuIndex} className="mc-sidebar-menu-item">
                {menu.submenus ? (
                  <>
                    {getDataas ? (
                      <button
                        type="button"
                        className="mc-sidebar-menu-btn"
                        onClick={handleDropdown}
                      >
                        <i className="material-icons">{menu.icon}</i>
                        <span>{t(menu.text)}</span>
                        {menu.badge?.text && (
                          <sup className={menu.badge.variant}>
                            {t(menu.badge.text)}
                          </sup>
                        )}
                        {menu.badge?.count && (
                          <sup className={menu.badge.variant}>
                            {n(menu.badge.count)}
                          </sup>
                        )}
                        {currentLanguage?.dir === "ltr" ? (
                          <small className="material-icons right">
                            chevron_right
                          </small>
                        ) : (
                          <small className="material-icons left">
                            chevron_left
                          </small>
                        )}
                      </button>
                    ) : (
                      <></>
                    )}

                    <ul className="mc-sidebar-dropdown-list">
                      {menu.submenus.map((submenu, submenusIndex) => (
                        <li
                          key={submenusIndex}
                          className="mc-sidebar-dropdown-item"
                        >
                          <Link
                            onClick={(e) => handleOptionClick(e, menu.text)}
                            to={submenu.path}
                            className="mc-sidebar-dropdown-link"
                          >
                            {t(submenu.text)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link
                    onClick={(e) => handleOptionClick(e, menu.text)}
                    to={menu.path}
                    className="mc-sidebar-menu-btn"
                  >
                    <i className="material-icons">{menu.icon}</i>
                    <span>{t(menu.text)}</span>
                    {menu.badge?.count && (
                      <sup className={menu.badge.variant}>
                        {n(menu.badge.count)}
                      </sup>
                    )}
                    {menu.badge?.text && (
                      <sup className={menu.badge.variant}>
                        {t(menu.badge.text)}
                      </sup>
                    )}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </menu>
      ))}
    </aside>
  );
}
